import React from "react";
import call from "../../assets/call.png";
import GetInTouch from "../Home/GetInTouch/GetInTouch";
const PrivacyPolicy = () => {
  return (
    <>
      <div class="hero for-inner">
        <div class="container">
          <div class="hero-grid inner">
            <div class="hero-w-width on-inner">
              <h1 class="display-1">
                Privacy <span class="gray-text-color">Policy</span>
              </h1>
            </div>
          </div>
        </div>
      </div>
      <div class="section legal">
        <div class="container">
          <div>
            <div class="leagl-wrapper">
              <div
                data-w-id="eb6b77d4-5c7b-d30c-b6da-7c7144717a91"
                class="legal-wrapper"
              >
                <p>Effective Date: 17 Oct 2024</p>
                <div class="margin-30px">
                  <p class="terms-paragraph">
                    <strong>
                      ORE Migration Services PTY Ltd T/A Win Migration Group
                      (ABN 11 640 885 623)
                    </strong>
                    (we, us, or our) is committed to protecting your personal
                    information in accordance with the Australian Privacy
                    Principles (APPs) under the Privacy Act 1988 (Cth) and the
                    Privacy and Data Protection Act 2014 (Vic). This Privacy
                    Policy outlines how we collect, use, disclose, and store
                    your personal information.
                  </p>
                </div>
                <div class="margin-30px">
                  <h4 class="heading-3">
                    <strong> 1: The information we collect</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      <strong>Personal information</strong>: Personal
                      information refers to any information or opinion that
                      identifies or could reasonably identify an individual. The
                      types of personal information we may collect include, but
                      are not limited to:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">your name;</li>
                      <li class="terms-list-item">
                        Photograph (for visa applications)
                      </li>
                      <li class="terms-list-item">
                        Contact details (email, phone number, address)
                      </li>
                      <li class="terms-list-item">
                        Employment details, including job title and employer
                      </li>
                      <li class="terms-list-item">Date of birth</li>
                      <li class="terms-list-item">
                        Financial details such as credit card or other payment
                        information (via third-party payment processors)
                      </li>
                      <li class="terms-list-item">
                        Sensitive information such as racial/ethnic origin,
                        criminal records, and health information (with your
                        consent)
                      </li>
                      <li class="terms-list-item">
                        Information about products and services provided to you
                        or that you have enquired about
                      </li>
                      <li class="terms-list-item">
                        Browser session and geo-location data, device and
                        network information
                      </li>
                      <li class="terms-list-item">
                        support requests submitted to us and our response to
                        you;
                      </li>
                      <li class="terms-list-item">
                        Other personal details relevant to migration and visa
                        services
                      </li>
                    </ul>
                    <p class="terms-paragraph">
                      ‍<strong>Sensitive information</strong>: Sensitive
                      information includes racial or ethnic origin, health
                      information, criminal records, and other data given
                      special protection under the law. We only collect
                      sensitive information with your consent or when required
                      by law.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      2: How we collect personal information
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We collect personal information in several ways,
                      including:
                    </p>
                    <ul role="list">
                      <li class="terms-list-item">
                        Directly: When you provide information via our website,
                        phone, email, or during consultations.
                      </li>
                      <li class="terms-list-item">
                        Indirectly: Through cookies, analytics providers, and
                        interactions with our website.
                      </li>
                      <li class="terms-list-item">
                        From third parties: Information from third-party service
                        providers or government agencies such as the Department
                        of Home Affairs.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      3. Use and Disclosure of Personal Information
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We collect, hold, use, and disclose personal information
                      to:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">
                        Provide our migration services, including reviewing visa
                        applications and offering migration advice
                      </li>
                      <li class="terms-list-item">
                        Communicate with you about services, respond to queries,
                        and provide updates
                      </li>
                      <li class="terms-list-item">
                        Handle billing, invoicing, and administrative tasks
                      </li>
                      <li class="terms-list-item">
                        Conduct market research and improve our services
                      </li>
                      <li class="terms-list-item">
                        Send you promotional materials, where consent is
                        provided
                      </li>
                      <li class="terms-list-item">
                        Comply with legal obligations, such as reporting to
                        government agencies
                      </li>
                    </ul>
                    <p class="terms-paragraph">
                      <strong>Sensitive Information</strong>: WWe will only use
                      or disclose sensitive information for the purposes to
                      which you have consented or as required by law, such as
                      assisting with visa applications or providing accurate
                      migration advice.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      4. Disclosure of Personal Information to Third Parties
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      We may disclose your personal information to:
                    </p>
                    <ul role="list" class="list">
                      <li class="terms-list-item">
                        Third-party service providers (e.g., IT providers, web
                        hosting, payment processors)
                      </li>
                      <li class="terms-list-item">
                        Government authorities, such as the Department of Home
                        Affairs
                      </li>
                      <li class="terms-list-item">
                        Courts, tribunals, or regulatory bodies when required
                      </li>
                      <li class="terms-list-item">
                        Marketing providers like Google Analytics and Facebook
                        Pixel for advertising purposes
                      </li>
                      <li class="terms-list-item">
                        Any party to whom our business is transferred in whole
                        or part
                      </li>
                      <li class="terms-list-item">
                        Legal or law enforcement agencies when necessary
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">5. Overseas Disclosure</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p class="terms-paragraph">
                      While we store personal information in Australia, we may
                      transfer your data to overseas recipients if required to
                      provide our services. We will take reasonable steps to
                      ensure that such overseas recipients protect your personal
                      information in a manner consistent with Australian privacy
                      laws.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">Your Rights</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      <strong>Access and Correction</strong>: You have the right
                      to request access to personal information we hold about
                      you and to request corrections if any information is
                      inaccurate, out-of-date, or incomplete.
                    </p>
                    <p>
                      <strong>Opt-Out and Unsubscribe</strong>: You may opt out
                      of marketing communications by contacting us or using the
                      unsubscribe link in our emails.
                    </p>
                    <p>
                      <strong>Complaints</strong>: If you believe we have
                      breached the APPs or mishandled your personal information,
                      you can lodge a complaint. We will investigate your
                      concerns and respond to you promptly. You also have the
                      right to escalate your complaint to the Office of the
                      Australian Information Commissioner (OAIC).
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      7. Storage and Security of Personal Information
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      We take reasonable steps to protect your personal
                      information from misuse, loss, and unauthorized access.
                      This includes the use of secure storage systems,
                      encryption, and restricted access. However, we cannot
                      guarantee the security of information transmitted over the
                      internet.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">Cookies</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      We use cookies on our website to enhance user experience
                      and collect data for advertising and analytics purposes.
                      You can manage cookies through your browser settings.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      9. Links to Other Websites
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      Our website may contain links to external websites. We are
                      not responsible for the privacy practices of other
                      websites and encourage you to review their privacy
                      policies.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">
                      10. Amendments to this Privacy Policy
                    </strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      We may update this policy periodically. Any changes will
                      be posted on our website. We encourage you to review this
                      policy regularly to stay informed of any updates.
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <h4>
                    <strong class="bold-text">11. Contact Us</strong>
                    <br />
                  </h4>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      For questions or concerns regarding this Privacy Policy or
                      to request access to your personal information, please
                      contact us at:
                    </p>
                  </div>
                </div>
                <div class="margin-30px">
                  <div class="rich-text-block-2 w-richtext">
                    <p>
                      ORE Migration Services PTY Ltd T/A Win Migration Group ABN
                      11 640 885 623
                    </p>
                    <p>
                      Email:
                      <a href="mailto:contact@winmigrationgroup.com">
                        contact@winmigrationgroup.com
                      </a>
                    </p>
                    <p>Last updated: 17 Oct 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <GetInTouch />
    </>
  );
};

export default PrivacyPolicy;
